// GENERATED by tools/content/build_help.py from content/help/package.yaml — do not edit by hand.
// Change the YAML, then run:  python tools/content/build_help.py
// CI fails when this file is out of date (build_help.py --check).
//
// Help-line data for Help now (Tool Plan §12, D-69; I-1a batch 5). Every number here passed the
// validator's hard guard: verified on its official page, with the date. The chat links are the only
// outside addresses in the app source; they open only on the person's tap, as plain links.

import type { HelpPackage } from './help'

export const HELP_PACKAGE: HelpPackage = {
  "id": "help",
  "version": 1,
  "status": "draft",
  "items": [
    {
      "id": "mda",
      "group": "strip-danger",
      "label": "MDA",
      "tel": "101",
      "hours": "24/7",
      "verified": true,
      "verifiedDate": "2026-10-14"
    },
    {
      "id": "police",
      "group": "strip-danger",
      "label": "Police",
      "tel": "100",
      "verified": true,
      "verifiedDate": "2026-10-14"
    },
    {
      "id": "eran",
      "group": "strip-talk",
      "label": "ERAN",
      "title": "ERAN — emotional first aid",
      "tel": "1201",
      "hours": "24/7",
      "chatUrl": "https://wa.me/972528451201",
      "chatKind": "whatsapp",
      "chatHours": "not 24/7 · hours to verify",
      "verified": true,
      "verifiedDate": "2026-10-14"
    },
    {
      "id": "natal",
      "group": "line",
      "label": "NATAL",
      "title": "NATAL — trauma (terror and war)",
      "tel": "*3362",
      "hours": "24/7",
      "verified": true,
      "verifiedDate": "2026-10-14"
    },
    {
      "id": "sahar",
      "group": "line",
      "label": "Sahar",
      "title": "Sahar — online chat",
      "chatUrl": "https://sahar.org.il/",
      "chatKind": "web",
      "chatHours": "Sun–Thu 16:00–03:00 · Fri, Sat and holiday eves 18:00–00:00",
      "verified": true,
      "verifiedDate": "2026-10-14"
    }
  ]
}
